module Core {
    angular.module('core')
        .constant("smartAppBannerConfig", {});
}